module.exports = __webpack_public_path__ + "img/redhawk2.9e300f7c.png";